
import { Alert } from "antd";

export default function AlertError(props) {
    return (
        <>
            <Alert message="Error" description={props.message} type="error" showIcon />
        </>
    );
}